import React from 'react';
import { cn } from '@/lib/utils';

type CurrencyAmountProps = {
  amount: number;
  currency?: string;
  locale?: string;
  placeholder?: string;
  className?: string;
  integerClassName?: string;
  currencyClassName?: string;
  fractionClassName?: string;
  superScriptCurrency?: boolean;
  superScriptFraction?: boolean;
};

export function CurrencyAmount(props: CurrencyAmountProps) {
  const {
    currency = 'EUR',
    locale = 'en',
    amount,
    placeholder = '—',
    className = '',
    integerClassName = '',
    currencyClassName = '',
    fractionClassName = '',
    // superScriptCurrency = false,
    // superScriptFraction = false,
  } = props;

  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
  };

  if (!amount) {
    return <span className={cn('CurrencyAmount', {})}>{placeholder}</span>;
  }
  const formatter = new Intl.NumberFormat(locale, options);
  const parts = formatter.formatToParts(parseFloat(amount.toFixed(2)));

  let currencyPart,
    integerPart = '',
    fractionPart;

  parts.forEach(({ type, value }) => {
    if (type === 'currency') {
      currencyPart = value;
    }

    if (type === 'integer' || type === 'group') {
      integerPart += value;
    }

    if (type === 'fraction' || type === 'decimal') {
      fractionPart = value;
    }
  });

  return (
    <span className={cn('currency-amount', className)}>
      <span className={'currency ' + currencyClassName}>{currencyPart} </span>
      <span className={'integer ' + integerClassName}>{integerPart}</span>
      {Boolean(fractionPart) && (
        <span className={cn('fraction', fractionClassName)}>.{fractionPart}</span>
      )}
    </span>
  );
}

export default CurrencyAmount;
